import { PlusIcon, SaveIcon, Trash2Icon } from "lucide-react";

import { Button } from "@/components/ui/button";

import type { Persona } from "../../hooks/useSandboxPersonas";
import ExportButton from "./ExportButton";
import ImportButton from "./ImportButton";
import PersonaSelect from "./PersonaSelect";

interface ToolbarProps {
  personas: Persona[];
  currentPersona: Persona | null;
  onNew: () => void;
  onLoad: (id: string) => void;
  onSave: () => void;
  onDelete: () => void;
  onExportPersona: () => void;
  onExportConfig: () => void;
  onImportPersona: (file: File) => void;
  onImportConfig: (file: File) => void;
  onLoadUser: (userId: string) => Promise<void>;
  isLoadingUser: boolean;
}

const Toolbar = ({
  personas,
  currentPersona,
  onNew,
  onLoad,
  onSave,
  onDelete,
  onExportPersona,
  onExportConfig,
  onImportPersona,
  onImportConfig,
  onLoadUser,
  isLoadingUser,
}: ToolbarProps) => {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-border pb-4">
      <PersonaSelect
        personas={personas}
        currentPersona={currentPersona}
        onLoad={onLoad}
      />
      <Button variant="outline" size="sm" onClick={onNew}>
        <PlusIcon className="mr-1 h-3.5 w-3.5" />
        New
      </Button>
      <Button variant="outline" size="sm" onClick={onSave}>
        <SaveIcon className="mr-1 h-3.5 w-3.5" />
        Save
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onDelete}
        disabled={!currentPersona}
        className="text-destructive hover:text-destructive"
      >
        <Trash2Icon className="mr-1 h-3.5 w-3.5" />
        Delete
      </Button>
      <ExportButton
        disableExportPersona={!currentPersona}
        onExportPersona={onExportPersona}
        onExportConfig={onExportConfig}
      />
      <ImportButton
        onImportPersona={onImportPersona}
        onImportConfig={onImportConfig}
        onLoadUser={onLoadUser}
        isLoadingUser={isLoadingUser}
      />
    </div>
  );
};

export default Toolbar;
